import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

/**
 * Numeric input component for displaying the calculated next service inspection mileage of a vehicle.
 * This field is typically calculated automatically based on the last service inspection mileage and service inspection interval.
 * Used in service interval tracking to show at what mileage a service inspection should be performed next.
 */
export function NextServiceInspectionMileageInput() {
  return (
    <Field
      type="number"
      name="serviceIntervals.serviceInspection.nextServiceInspectionMileage"
      label={i18n.t('entity.vehicle.labels.nextServiceInspection')}
      suffix={i18n.t('general.metric.km')}
    />
  );
}
